import React from "react";
import {
    useGetPendingBingxQuery,
    useCancelBingxRequestMutation,
    useConfirmBingxMutation,
} from "../api";

export const AdminBingx: React.FC = () => {
    const { data: requests, isLoading } = useGetPendingBingxQuery(undefined, {
        pollingInterval: 30000,
    });

    const [cancel, { isLoading: isCancelling }] =
        useCancelBingxRequestMutation();
    const [confirm, { isLoading: isConfirming }] = useConfirmBingxMutation();

    const handleCancel = async (id: number) => {
        if (window.confirm("Отменить заявку на пополнение?")) {
            try {
                await cancel(id).unwrap();
                alert("Заявка отменена");
            } catch (error: any) {
                alert("Ошибка: " + (error.data?.message || error.message));
            }
        }
    };

    const handleConfirm = async (request: any) => {
        if (!request.api_seen) {
            const ok = window.confirm(
                "⚠️ По API BingX депозит ещё НЕ виден на бирже.\n\n" +
                    "Точно подтвердить вручную? Юзеру зачислится сумма из заявки, даже если денег нет."
            );
            if (!ok) return;
        } else {
            if (
                !window.confirm(
                    `Подтвердить? На бирже видно ${request.api_amount ?? "?"} USDT.`
                )
            ) {
                return;
            }
        }
        try {
            await confirm(request.id).unwrap();
            alert("Заявка подтверждена");
        } catch (error: any) {
            alert("Ошибка: " + (error.data?.message || error.message));
        }
    };

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleString("ru-RU");
    };

    if (isLoading) {
        return <div className="p-6">Загрузка...</div>;
    }

    const items = requests?.data || [];

    return (
        <div className="p-6 space-y-6">
            <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                    Bingx заявки на пополнение
                </h1>
                <p className="text-sm text-gray-500 mt-1">
                    Автозачисление идёт cron каждые 5 мин. Здесь — ручной
                    контроль. Статус по API: пришёл ли депозит на биржу.
                </p>
            </div>

            {items.length > 0 ? (
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                            <thead className="bg-gray-50 dark:bg-gray-900">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Пользователь / Кошелек
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Сумма / Сеть
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Дата
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        API BingX
                                    </th>
                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Действия
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                {items.map((request: any) => {
                                    const seen = !!request.api_seen;
                                    return (
                                        <tr key={request.id}>
                                            <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">
                                                <div className="font-medium truncate max-w-[200px]">
                                                    {request.user_name}{" "}
                                                    {request.user_surname}
                                                </div>
                                                <div className="text-gray-500 text-xs">
                                                    id {request.user_id}
                                                    {request.wallet_email
                                                        ? ` · ${request.wallet_email}`
                                                        : ""}
                                                </div>
                                                <div className="text-gray-500 text-xs font-mono break-all">
                                                    {request.wallet_address}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                                                <div className="font-medium">
                                                    {request.amount}{" "}
                                                    {request.currency}
                                                </div>
                                                <div className="text-gray-500 text-xs">
                                                    {request.network}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                                {formatDate(request.created_at)}
                                            </td>
                                            <td className="px-6 py-4 text-sm">
                                                {seen ? (
                                                    <div>
                                                        <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800">
                                                            Есть на бирже
                                                        </span>
                                                        <div className="text-xs text-emerald-700 mt-1">
                                                            API:{" "}
                                                            {request.api_amount}{" "}
                                                            USDT
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                                                            Не видно
                                                        </span>
                                                        {request.api_status ===
                                                            "no_keys" ||
                                                        request.api_status ===
                                                            "no_account" ? (
                                                            <div className="text-xs text-red-600 mt-1 max-w-[180px]">
                                                                {request.api_message}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-6 py-4 text-center">
                                                <div className="flex flex-col items-center gap-1.5">
                                                    <div className="flex space-x-2 justify-center">
                                                        <button
                                                            onClick={() =>
                                                                handleConfirm(
                                                                    request
                                                                )
                                                            }
                                                            disabled={
                                                                isConfirming ||
                                                                isCancelling
                                                            }
                                                            className={`px-3 py-1 rounded-md text-sm text-white disabled:opacity-50 ${
                                                                seen
                                                                    ? "bg-green-600 hover:bg-green-700"
                                                                    : "bg-amber-600 hover:bg-amber-700"
                                                            }`}
                                                        >
                                                            Подтвердить
                                                        </button>
                                                        <button
                                                            onClick={() =>
                                                                handleCancel(
                                                                    request.id
                                                                )
                                                            }
                                                            disabled={
                                                                isConfirming ||
                                                                isCancelling
                                                            }
                                                            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded-md text-sm disabled:opacity-50"
                                                        >
                                                            Отменить
                                                        </button>
                                                    </div>
                                                    {!seen &&
                                                        request.api_status !==
                                                            "no_keys" &&
                                                        request.api_status !==
                                                            "no_account" && (
                                                            <p className="text-[11px] text-red-600 font-medium max-w-[220px] leading-snug">
                                                                По API эти
                                                                деньги ещё не
                                                                пришли на биржу
                                                                — не
                                                                подтверждайте
                                                                случайно
                                                            </p>
                                                        )}
                                                    {seen && (
                                                        <p className="text-[11px] text-emerald-700 max-w-[220px] leading-snug">
                                                            Депозит виден в
                                                            BingX — можно
                                                            подтвердить, если
                                                            авто не успело
                                                        </p>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
                    <p className="text-center text-gray-500 dark:text-gray-400">
                        Нет ожидающих заявок
                    </p>
                </div>
            )}
        </div>
    );
};
